import './ShipperForm.scss';

import { Form, Input } from 'antd';
import { FormProps } from 'antd/lib';
import { useTranslation } from 'react-i18next';

import { COUNTRY, useCountryContext } from '@/contexts/CountryContext';

interface ShipperFormProps {
  formProps: FormProps;
  edit?: boolean;
}

const ShipperForm = (props: ShipperFormProps) => {
  const { t } = useTranslation();
  const { formProps, edit } = props;
  const { initialValues } = formProps;
  const { isBrasilSelected } = useCountryContext();

  return (
    <Form
      {...formProps}
      onFinish={values => {
        if (isBrasilSelected) {
          values.pais = COUNTRY.BRASIL;
        }

        formProps.onFinish?.(values);
      }}
      layout="vertical"
      className="ShipperForm">
      {edit && initialValues?.id && (
        <div className="ShipperFormShowDataId">
          Id del operador: <span>{initialValues.id}</span>
        </div>
      )}
      <div className="ShipperFormDataContainer">
        <Form.Item
          label={t('Nombre')}
          name={'name'}
          rules={[
            {
              required: true,
              message: t('El nombre es requerido'),
            },
          ]}>
          <Input />
        </Form.Item>
        <Form.Item label={t('Dirección')} name={'address'}>
          <Input />
        </Form.Item>
        <Form.Item label={t('Teléfono')} name={'phone'}>
          <Input />
        </Form.Item>
        <Form.Item label={`${t('Teléfono')} 2`} name={'phone2'}>
          <Input />
        </Form.Item>
        <Form.Item
          label={t('Email')}
          name={'email'}
          rules={[{ type: 'email', message: t('Email inválido') }]}>
          <Input />
        </Form.Item>
        <Form.Item
          label={t('Link de tracking')}
          name={'tracking_link'}
          rules={[{ type: 'url', message: t('URL inválido') }]}>
          <Input />
        </Form.Item>
      </div>
    </Form>
  );
};

export default ShipperForm;
